import { Provider as Provider$1, useLocalModel as useLocalModel$1, useModel as useModel$1, extend, handleEffect, updateState, createModel, createApp, connect, connectLocal, useReduckContext, combineReducers, ReactReduxContext, createReduxStore, withReduckContext, useStaticModel, useStaticLocalModel } from '@reduck/core';
export { ReactReduxContext, combineReducers, connect, connectLocal, createApp, createModel, createReduxStore, createStore, extend, handleEffect, updateState, useReduckContext, useStaticLocalModel, useStaticModel, withReduckContext } from '@reduck/core';
import React, { useContext } from 'react';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var Context = React.createContext(null);

var Provider = function Provider(_ref) {
  var store = _ref.store,
      children = _ref.children;
  return Provider$1({
    store: store,
    children: children,
    context: Context
  });
};

var useInGarfish = false;
function markGarfish() {
  useInGarfish = true;
}

function transferToUseMasterHook(modelHook) {
  return function (namespaces, deps) {
    var contextValue = useContext(Context);

    if (!contextValue) {
      console.error("[@jupiter-app/plugin-state]: please ensure App is wrapped in GarfishContextProvider");
      return;
    }

    var store = contextValue.store;
    return modelHook(namespaces2ReduckModel(Array.isArray(namespaces) ? namespaces : [namespaces], store), deps, {}, {
      context: Context
    });
  };
}

function namespaces2ReduckModel(namespaces, store) {
  return namespaces.map(function (ns) {
    if (typeof ns === 'string') {
      var _store$_context, _store$_context$_mode;

      return (store === null || store === void 0 ? void 0 : (_store$_context = store._context) === null || _store$_context === void 0 ? void 0 : (_store$_context$_mode = _store$_context._models) === null || _store$_context$_mode === void 0 ? void 0 : _store$_context$_mode[ns]) || console.warn("[@jupiter-app/plugin-state]: ".concat(ns, " is not loaded by master App's store, please check"));
    }

    return false;
  }).filter(Boolean);
}

function likeSameModel(modelA, modelB) {
  if (!modelA || !modelB) {
    return false;
  }

  if (Object.keys(modelA.state || {}).toString() === Object.keys(modelB.state || {}).toString() && Object.keys(modelA.actions || {}).toString() === Object.keys(modelB.actions || {}).toString()) {
    return true;
  }

  return false;
}

function wrapUseModel(useModelFn) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (!useInGarfish) {
      return useModelFn.apply(void 0, args);
    }

    var contextValue = useContext(Context);

    if (!contextValue) {
      return useModelFn.apply(void 0, args);
    }

    var models = [];

    if (Array.isArray(args[0])) {
      models = args[0];
    } else {
      models = [args[0]];
    }

    models = models.filter(function (model) {
      if (typeof model === 'function') {
        return false;
      }

      return true;
    });

    if (models.every(function (model) {
      var _contextValue$store, _contextValue$store$_, _contextValue$store$_2;

      return likeSameModel((_contextValue$store = contextValue.store) === null || _contextValue$store === void 0 ? void 0 : (_contextValue$store$_ = _contextValue$store._context) === null || _contextValue$store$_ === void 0 ? void 0 : (_contextValue$store$_2 = _contextValue$store$_._models) === null || _contextValue$store$_2 === void 0 ? void 0 : _contextValue$store$_2[model.name || model.namespace], model);
    })) {
      // 第四个参数传入context
      args[3] = {
        context: Context
      };
    }

    return useModelFn.apply(void 0, args);
  };
}

var useMasterModel = transferToUseMasterHook(useModel$1);
var useMatserLocalModel = transferToUseMasterHook(useLocalModel$1);
var useModel = wrapUseModel(useModel$1);
var useLocalModel = wrapUseModel(useLocalModel$1);

function filterPluginRouterAndImmer(plugins) {
  return plugins.filter(function (plugin) {
    return plugin.__name__ === '@reduck/plugin-router' || plugin.__name__ === '@reduck/plugin-immer' || plugin.__name__ === '@reduck/plugin-persist';
  });
}

function reduckPlugin() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var specialHook = {
    onCreateApp: function onCreateApp(AppWrapper, appConfig) {
      if (appConfig.plugins.some(function (plugin) {
        return plugin.__name__ === '@jupiter-app/plugin-garfish' || plugin.__name__ === '@jupiter-app/plugin-gar-mini';
      })) {
        markGarfish();
      }

      var routerAndImmerPlugins = filterPluginRouterAndImmer(appConfig.plugins || []);

      if (!config.plugins) {
        config.plugins = [];
      }

      return createApp(_objectSpread2(_objectSpread2({}, config), {}, {
        plugins: [].concat(_toConsumableArray(routerAndImmerPlugins), _toConsumableArray(config.plugins))
      }))(AppWrapper);
    }
  };

  var plugin = function plugin() {
    return {
      name: '@jupiter-app/plugin-state'
    };
  };

  plugin.__SPECIALHOOK__ = specialHook;
  plugin.__name__ = '@jupiter-app/plugin-state';
  return plugin;
}
reduckPlugin.extend = extend;
reduckPlugin.handleEffect = handleEffect;
reduckPlugin.updateState = updateState;
reduckPlugin.createModel = createModel;
reduckPlugin.createApp = createApp;
reduckPlugin.useModel = useModel;
reduckPlugin.connect = connect;
reduckPlugin.useLocalModel = useLocalModel;
reduckPlugin.connectLocal = connectLocal;
reduckPlugin.useReduckContext = useReduckContext;
reduckPlugin.combineReducers = combineReducers;
reduckPlugin.ReactReduxContext = ReactReduxContext;
reduckPlugin.createReduxStore = createReduxStore;
reduckPlugin.withReduckContext = withReduckContext;
reduckPlugin.useStaticModel = useStaticModel;
reduckPlugin.useStaticLocalModel = useStaticLocalModel;
reduckPlugin.useMasterModel = useMasterModel;
reduckPlugin.useMatserLocalModel = useMatserLocalModel;
reduckPlugin.MasterReduckProvider = Provider;

export default reduckPlugin;
export { Provider as MasterReduckProvider, useLocalModel, useMasterModel, useMatserLocalModel, useModel };
//# sourceMappingURL=state.esm.js.map
